



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import version from "@/version";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue
    }
})
export default class QuarterlyCashFlowStatement extends Vue {
        // 下载
    downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/cashflow/qua?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    //改变时间
    period: String[] = []; // 日期
    dataList: CashFlow.CashQuaterData[] = [];
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        let data = [];
        Vue.axios
            .post(`cash/quarter/finddetail`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period
            })
            .then(res => {
                this.dataList = res.data;
            });
    }
}
